module.exports = __webpack_public_path__ + "static/media/erxing.fbf86805.png";